import React, { useEffect, useState } from 'react';
import { IntroAnimation } from './components/IntroAnimation';
import { Hero } from './components/Hero';
import { Specialties } from './components/Specialties';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { WhyFla } from './components/WhyFla';
import { About } from './components/About';
import { Cta } from './components/Cta';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
export function App() {
  const [showIntro, setShowIntro] = useState(true);
  useEffect(() => {
    // Hide intro after animation completes (adjust timing as needed based on IntroAnimation component)
    const timer = setTimeout(() => {
      setShowIntro(false);
    }, 2500); // 2.5 seconds
    return () => clearTimeout(timer);
  }, []);
  return <div className="bg-black min-h-screen text-offwhite font-sans overflow-x-hidden" data-id="element-0">
      {showIntro && <IntroAnimation data-id="element-1" />}

      {/* Main Content - fade in after intro */}
      <div className={`transition-opacity duration-1000 ${showIntro ? 'opacity-0' : 'opacity-100'}`} data-id="element-2">
        <Navbar data-id="element-3" />
        <Hero data-id="element-4" />
        <Specialties data-id="element-5" />
        <Gallery data-id="element-6" />
        <Reviews data-id="element-7" />
        <WhyFla data-id="element-8" />
        <About data-id="element-9" />
        <Cta data-id="element-10" />
        <Footer data-id="element-11" />
      </div>
    </div>;
}